//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { useRecordContext, useUpdate, useNotify } from 'react-admin';
import {
	Card,
	CardContent,
	Typography,
	Stack,
	TextField,
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	Button,
	Box,
	Divider,
} from '@mui/material';

export const ConnectorConfigInfos = () => {
	const record = useRecordContext();
	const [update, { isLoading: isUpdating }] = useUpdate();
	const notify = useNotify();

	const [name, setName] = useState('');
	const [description, setDescription] = useState('');
	const [purpose, setPurpose] = useState('');
	const [version, setVersion] = useState('');
	const [processVersion, setProcessVersion] = useState('1.0');
	const [apiUrl, setApiUrl] = useState('');
	const [gitProjectId, setGitProjectId] = useState('');

	useEffect(() => {
		if (record) {
			setName(record.name || '');
			setDescription(record.description || '');
			setPurpose(record.purpose || '');
			setVersion(record.version || '');
			setProcessVersion(record.processVersion || '1.0');
			setApiUrl(record.apiUrl || '');
			setGitProjectId(record.gitProjectId || '');
		}
	}, [record]);

	const handleSave = () => {
		update(
			'connectors',
			{
				id: record.id,
				data: {
					name,
					description,
					purpose,
					version,
					processVersion,
					apiUrl,
					gitProjectId,
				},
				previousData: record,
			},
			{
				onSuccess: () => {
					notify('Connecteur mis à jour', { type: 'success' });
				},
				onError: (error: any) => {
					notify(`Erreur: ${error.message}`, { type: 'error' });
				},
			}
		);
	};

	if (!record) return null;

	return (
		<Card>
			<CardContent>
				<Typography variant="h6" gutterBottom>
					Informations du connecteur
				</Typography>
				<Divider sx={{ mb: 3 }} />

				<Stack spacing={3}>
					<TextField
						label="Nom"
						value={name}
						onChange={(e) => setName(e.target.value)}
						fullWidth
						size="small"
					/>

					<TextField
						label="SKU"
						value={record.sku || ''}
						fullWidth
						size="small"
						disabled
						helperText="Le SKU ne peut pas être modifié"
					/>

					<TextField
						label="Description"
						value={description}
						onChange={(e) => setDescription(e.target.value)}
						fullWidth
						size="small"
						multiline
						rows={2}
						placeholder="Description du connecteur et de ses fonctionnalités"
					/>

					<TextField
						label="Purpose"
						value={purpose}
						onChange={(e) => setPurpose(e.target.value)}
						fullWidth
						size="small"
						multiline
						rows={2}
						placeholder="À quoi sert ce connecteur, quel usage métier"
					/>

					<Stack direction="row" spacing={2}>
						<TextField
							label="Version"
							value={version}
							onChange={(e) => setVersion(e.target.value)}
							fullWidth
							size="small"
							placeholder="ex: 2.1.0"
						/>

						<FormControl fullWidth size="small">
							<InputLabel>Process Version</InputLabel>
							<Select
								value={processVersion}
								label="Process Version"
								onChange={(e) => setProcessVersion(e.target.value)}
							>
								<MenuItem value="1.0">1.0</MenuItem>
								<MenuItem value="2.0">2.0</MenuItem>
							</Select>
						</FormControl>
					</Stack>

					<Divider />

					<Typography variant="subtitle2" color="textSecondary">
						Configuration API
					</Typography>

					<TextField
						label="API URL"
						value={apiUrl}
						onChange={(e) => setApiUrl(e.target.value)}
						fullWidth
						size="small"
						placeholder="https://api.example.com"
					/>

					<Divider />

					<Typography variant="subtitle2" color="textSecondary">
						GitLab
					</Typography>

					<TextField
						label="GitLab Project ID"
						value={gitProjectId}
						onChange={(e) => setGitProjectId(e.target.value)}
						fullWidth
						size="small"
						placeholder="ex: 76376391"
						helperText="ID du projet GitLab contenant le code du connecteur"
					/>

					<Box>
						<Button
							variant="contained"
							onClick={handleSave}
							disabled={isUpdating}
						>
							{isUpdating ? 'Enregistrement...' : 'Enregistrer'}
						</Button>
					</Box>
				</Stack>
			</CardContent>
		</Card>
	);
};
